"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientsform = exports.clientsColumns = void 0;
const tools_1 = require("../outils/tools");
const globals_1 = require("models/globals");
exports.clientsColumns = [
    { id: "unid", header: (0, globals_1._)("N°"), sort: "int", css: { "text-align": "right" }, adjust: true },
    { id: "codeClient", header: (0, globals_1._)("Code"), sort: "text", adjust: true },
    { id: "codeMnemo", header: (0, globals_1._)("Nom court"), width: 80, sort: "text", adjust: true, hidden: true },
    { id: "adresseNom", header: (0, globals_1._)("Nom"), sort: "text", adjust: true },
    { id: "telephone"
        // , header : [ _("Téléphone"), { content:"textFilter" }]
        ,
        header: (0, globals_1._)("Téléphone"),
        sort: "text", adjust: true },
    { id: "mobile", header: (0, globals_1._)("Portable"), sort: "text", adjust: true },
    { id: "email", header: (0, globals_1._)("Courriel"), sort: "text", adjust: true },
    { id: "compteActif", header: (0, globals_1._)("Actif"), template: tools_1.custom_checkbox, adjust: true }
];
exports.clientsform = {
    view: "form",
    libelle: "Fiche client",
    scroll: true,
    id: "clientFormId",
    autocomplete: "off",
    // width : 900,
    elementsConfig: { maxWidth: 500, labelAlign: "right", labelWidth: 100,
        on: { onChange: function (newValue) { globals_1.lv2.clean(newValue, this); } }
    },
    elements: [
        {
            view: "text", name: "unid", label: (0, globals_1._)("Unid"), width: "400", hidden: true
        }, {
            cols: [{
                    view: "text",
                    name: "codeClient",
                    localId: "codeClientField",
                    label: (0, globals_1._)("Code client"),
                    width: "240",
                    attributes: { maxlength: 14 },
                    editor: "text",
                }, {
                    view: "checkbox",
                    name: "comptePro",
                    label: (0, globals_1._)("Professionnel"),
                    width: "160",
                    localId: "comptePro",
                    editor: "checkbox"
                }, {
                    view: "text",
                    name: "codeMnemo",
                    localId: "initialesField",
                    label: (0, globals_1._)("Nom court"),
                    width: "200",
                    attributes: { maxlength: 8 },
                    editor: "text",
                }]
        }, {
            cols: [{
                    view: "text",
                    name: "nom",
                    label: (0, globals_1._)("Nom"),
                    width: "260",
                    localId: "nomClient",
                    hidden: true,
                    attributes: { maxlength: 24 },
                    editor: "text"
                }, {
                    view: "text",
                    name: "prenom",
                    label: (0, globals_1._)("Prénom"),
                    width: "240",
                    localId: "prenomClient",
                    hidden: true,
                    attributes: { maxlength: 18 },
                    editor: "text"
                }, {
                    view: "text",
                    name: "adresseNom",
                    label: (0, globals_1._)("Nom"),
                    width: "400",
                    localId: "adresseNom",
                    hidden: false,
                    attributes: { maxlength: 40 },
                    editor: "text"
                }]
        }, {
            view: "text",
            name: "adresseSuite",
            label: (0, globals_1._)("Adresse"),
            width: "400",
            attributes: { maxlength: 40 },
            editor: "text"
        }, {
            view: "text",
            name: "adresseRue",
            label: (0, globals_1._)("N° et rue"),
            width: "400",
            attributes: { maxlength: 40 },
            editor: "text"
        }, {
            cols: [{
                    view: "text",
                    name: "adresseCP",
                    localId: "adresseCPField",
                    label: (0, globals_1._)("Code Postal"),
                    width: "180",
                    attributes: { maxlength: 5 },
                }, {
                    view: "text",
                    name: "adresseVille",
                    localId: "adresseVilleField",
                    label: (0, globals_1._)("Ville"),
                    width: "400",
                    labelWidth: 60,
                    attributes: { maxlength: 34 },
                    editor: "text"
                }]
        }, {
            view: "text",
            name: "adressePays",
            label: (0, globals_1._)("Pays"),
            width: "300",
            attributes: { maxlength: 24 },
            editor: "text"
        }, {
            cols: [{
                    view: "text",
                    name: "siret",
                    label: (0, globals_1._)("N° Siret"),
                    width: "300",
                    localId: "siret",
                    hidden: true,
                    attributes: { maxlength: 17 },
                    editor: "text"
                }, {
                    view: "text",
                    name: "numTVA",
                    label: (0, globals_1._)("Numéro TVA"),
                    width: "300",
                    localId: "numTVA",
                    hidden: true,
                    attributes: { maxlength: 15 },
                    editor: "text"
                }, { height: 1 }]
        }, {
            view: "text",
            name: "modeReglement",
            label: (0, globals_1._)("Règlement"),
            width: "400",
            attributes: { maxlength: 40 },
            editor: "text"
        }, {
            view: "text",
            name: "compteCompta",
            label: (0, globals_1._)("Comptabilité"),
            width: "250",
            attributes: { maxlength: 12 },
            tooltip: (0, globals_1._)("Compte comptable"),
            editor: "text"
        }, {
            cols: [{
                    view: "text",
                    name: "telephone",
                    label: (0, globals_1._)("Téléphone"),
                    width: "300",
                    attributes: { maxlength: 24 },
                    editor: "text"
                }, {
                    view: "text",
                    name: "mobile",
                    label: (0, globals_1._)("Mobile"),
                    width: "300",
                    attributes: { maxlength: 24 },
                    editor: "text"
                }]
        }, {
            view: "text",
            name: "email",
            localId: "emailField",
            label: (0, globals_1._)("Courriel"),
            width: "400",
            attributes: { maxlength: 40 },
            editor: "text",
            invalidMessage: (0, globals_1._)("L'adresse e-mail n'est pas valide")
        }, {
            view: "text",
            name: "noteFacture",
            label: (0, globals_1._)("Note facture"),
            width: "600",
            attributes: { maxlength: 80 },
            editor: "text",
            tooltip: (0, globals_1._)("Cette note sera ajoutée sur la facture du client."),
        }, {
            view: "textarea",
            name: "notes",
            label: (0, globals_1._)("Notes"),
            width: "600",
            height: "200",
            editor: "textarea"
        }, { template: " ", fillspace: true, height: 1, borderless: true }
    ],
    // rules:{
    // 	"email" : webix.rules.isEmail
    // }
};
